export default {
    adminUserModal: {
        isOpen: false,
    },
    adminRolesModal: {
        isOpen: false,
    },
};
